import { Reveal } from "../lib/motion";

const ITEMS = [
  "SaaS",
  "FinTech",
  "HealthTech",
  "IT Services",
  "Global Capability Centres",
  "High-growth companies",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-10 font-editorial italic text-xl md:text-2xl text-navy/50">
          {item}
        </span>
        <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-brand/70" />
      </span>
    ))}
  </div>
);

export const Proof = () => (
  <section data-testid="social-proof-section" className="overflow-hidden border-y border-border bg-mist py-16 md:py-20">
    <Reveal className="text-center">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-navy/45">
        Experience across stages, sectors and geographies
      </p>
    </Reveal>
    <div className="mask-fade-x mt-10">
      <div data-testid="proof-marquee" className="flex w-max animate-ticker hover:[animation-play-state:paused]">
        <Row />
        <Row />
      </div>
    </div>
  </section>
);
